<template>
  <div>
    <form-field-select
      label="Status"
      v-model="form.status"
      :validation-errors="validationErrors.status"
    >
      <option
        v-for="status in statuses"
        :key="status.value"
        :value="status.value"
      >{{ status.label }}</option>
    </form-field-select>

    <form-field-currency
      label="Earnest Amount"
      v-model="form.earnest_amount"
      :validation-errors="validationErrors.earnest_amount"
    ></form-field-currency>

    <form-field-switch
      label="Earnest Money Deposited"
      v-model="form.earnest_money_deposited"
      :validation-errors="validationErrors.earnest_money_deposited"
    ></form-field-switch>

    <form-field-currency
      label="Sale Amount"
      v-model="form.sale_amount"
      :validation-errors="validationErrors.sale_amount"
    ></form-field-currency>

    <form-field-date-picker
      label="Inspect By Date"
      v-model="form.inspect_by_date"
      :validation-errors="validationErrors.inspect_by_date"
      is-inline
      has-clear-button
    ></form-field-date-picker>

    <form-field-date-picker
      label="Assigned At"
      v-model="form.assigned_at"
      :validation-errors="validationErrors.assigned_at"
      is-inline
      has-clear-button
    ></form-field-date-picker>

    <form-field-date-picker
      label="Closing At"
      v-model="form.closing_at"
      :validation-errors="validationErrors.closing_at"
      is-inline
      has-clear-button
    ></form-field-date-picker>
  </div>
</template>

<script>
  import {FormMixin} from "./forms.mixin";
  import {ENUMS} from "../services/enums";

  export default {
    name: "WholesaleSellingInfoForm",
    props: ['formData'],
    mixins: [FormMixin],
    data() {
      return {
        form: {},
        validationErrors: {},
        defaultForm: {
          market_id: '',
          record_id: '',
          status: '',
          inspect_by_date: '',
          earnest_amount: '',
          earnest_money_deposited: '',
          assigned_at: '',
          closing_at: '',
          sale_amount: '',
        },
      }
    },
    created() {
      // This allows you to pass in formData without an id in order to add data to the defaultForm for the the create
      this.form = (this.formData && this.formData.id) ? this.$utils.clone(this.formData) : this.$utils.clone({...this.defaultForm, ...this.formData});
    },
    computed: {
      statuses() {
        return ENUMS.WholesaleSellingInfoStatusEnum;
      }
    },
    methods: {
      update() {
        return this.$api.wholesaleSellingInfos.update(this.form)
          .then(res => {
            this.$buefy.toast.open({
              message: 'WholesaleSellingInfo was updated',
              type: 'is-success'
            });

            return res;
          })
        },
      create() {
        return this.$api.wholesaleSellingInfos.create(this.form)
          .then(res => {
            this.$buefy.toast.open({
              message: 'WholesaleSellingInfo was created',
              type: 'is-success'
            });

            return res;
          })
        },
      // delete() {
      //   return this.$api.wholesaleSellingInfos.delete(this.form.id)
      //     .then(res => {
      //       this.$buefy.toast.open({
      //         message: 'WholesaleSellingInfo was archived',
      //         type: 'is-success'
      //       });
      //
      //       return res;
      //     });
      // },
      // restore() {
      //   return this.$api.wholesaleSellingInfos.restore(this.form.id)
      //     .then(res => {
      //       this.$buefy.toast.open({
      //         message: 'WholesaleSellingInfo was restored',
      //         type: 'is-success'
      //       });
      //
      //       return res;
      //     });
      // },
    },
  }
</script>

<style lang="scss" scoped>

</style>
